import React from "react";
import contentfulRichText from "../util/contentfulRichText";

export default ({ items }) =>
    <div className="o-text-grid u-container u-section-spacing">
        { items.map(({ content }, index) => (
            <div className="o-text-grid__item" key={ index }>
                { contentfulRichText(content) }
            </div>
        )) }
    </div>;
